module.exports = __webpack_public_path__ + "img/logo.9c4e1f6f.png";